import PropTypes from "prop-types";
import Label from "../Label/Label.js";
import styles from "./Slider.css";
import { useSlider } from "./useSlider";

const Slider = ({
  ariaLabel,
  ariaLabelledby,
  ariaControls,
  formatLabel,
  maxValue,
  minValue,
  onSliderDrag,
  onSliderKeyDown,
  onSliderDragStart,
  onSliderDragEnd,
  onFocus,
  onBlur,
  percentage,
  type,
  value,
  trackRef
}) => {
  const {
    isSelected,
    nodeRef,
    handleMouseDown,
    handleTouchStart,
    handleKeyDown,
    handleFocus,
    handleBlur
  } = useSlider(
    onSliderDrag,
    onSliderKeyDown,
    onSliderDragStart,
    onSliderDragEnd,
    onFocus,
    onBlur,
    type,
    trackRef
  );

  const containerStyle = {
    position: "absolute",
    left: `${(percentage || 0) * 100}%`
  };

  const sliderStyle = isSelected
    ? {
        backgroundColor: styles.selectedColor,
        borderColor: styles.selectedColor
      }
    : {};
  const labelStyle = {
    color: isSelected ? styles.selectedColor : styles.primaryColor
  };

  return (
    <div className={styles[`${type}ValueLabel`]}>
      <span className={styles.labelContainer}>
        <Label
          formatLabel={formatLabel}
          type="value"
          testid={`${type}ValueLabel`}
          labelStyle={labelStyle}
        >
          {value}
        </Label>
      </span>
      <span
        className={styles.sliderContainer}
        ref={nodeRef}
        style={containerStyle}
      >
        <div
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledby}
          aria-controls={ariaControls}
          aria-valuemax={maxValue}
          aria-valuemin={minValue}
          aria-valuenow={value}
          aria-valuetext={formatLabel ? formatLabel(value) : String(value)}
          className={styles.slider}
          draggable={false}
          onKeyDown={handleKeyDown}
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
          onFocus={handleFocus}
          onBlur={handleBlur}
          role="slider"
          tabIndex={0}
          style={sliderStyle}
          data-testid={`${type}Indicator`}
        />
      </span>
    </div>
  );
};

Slider.propTypes = {
  ariaLabel: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  ariaControls: PropTypes.string,
  formatLabel: PropTypes.func,
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  onSliderDrag: PropTypes.func.isRequired,
  onSliderKeyDown: PropTypes.func.isRequired,
  onSliderDragStart: PropTypes.func.isRequired,
  onSliderDragEnd: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  percentage: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  trackRef: PropTypes.shape({ current: PropTypes.any })
};

export default Slider;
